/**
 * iOS WKWebView 键盘弹出时 window.innerHeight（布局视口）不变，
 * 只有 window.visualViewport.height（视觉视口）收缩——两者之差即键盘遮挡高度。
 */
export function getKeyboardOverlap(layoutViewportHeight, visualViewport) {
  if (!visualViewport || typeof visualViewport.height !== 'number') return 0
  const overlap = layoutViewportHeight - visualViewport.height - (visualViewport.offsetTop || 0)
  return overlap > 0 ? overlap : 0
}
